import type { StateCreator } from "zustand"

import type { AppState, BgVideoSlice } from "@/store/types"

export const createBgVideoSlice: StateCreator<
  AppState,
  [],
  [],
  BgVideoSlice
> = (set) => ({
  bgVideoFile: null,
  bgVideoUrl: null,
  setBgVideo: (bgVideoFile, bgVideoUrl) =>
    set((s) => {
      if (s.bgVideoUrl && s.bgVideoUrl !== bgVideoUrl)
        URL.revokeObjectURL(s.bgVideoUrl)
      return { bgVideoFile, bgVideoUrl }
    }),
  clearBgVideo: () =>
    set((s) => {
      if (s.bgVideoUrl) URL.revokeObjectURL(s.bgVideoUrl)
      return { bgVideoFile: null, bgVideoUrl: null }
    }),
})
